export const CURRENCY_SYMBOLS: Record<string, string> = {
    CAD: 'C$',
    NOK: 'Kr.',
    USD: '$',
    EUR: '€',
    GBP: '£',
    DKK: 'Kr.',
    SEK: 'kr',
    RON: 'RON'
};